import { isStringArray } from '@/api/queries/utils';
import { isRecord } from '@/utils/filter/isRecord';
import type { ChatbotActiveFilters, ChatbotFilterValue } from '@/models/chatbot';

export function isChatbotFilterValue(value: unknown): value is ChatbotFilterValue {
  if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return true;
  }

  if (Array.isArray(value)) {
    return value.every(isChatbotFilterValue);
  }

  return isRecord(value) && Object.values(value).every(isChatbotFilterValue);
}

function isFilterRecord(value: unknown): value is Record<string, ChatbotFilterValue> {
  return isRecord(value) && Object.values(value).every(isChatbotFilterValue);
}

export function isChatbotActiveFilters(value: unknown): value is ChatbotActiveFilters {
  if (!isRecord(value)) {
    return false;
  }

  return (
    (!('globalFilters' in value) || isFilterRecord(value.globalFilters)) &&
    (!('localFilters' in value) || isFilterRecord(value.localFilters)) &&
    (!('resolvedCountryCodes' in value) || isStringArray(value.resolvedCountryCodes))
  );
}
